import React, { useState} from 'react';
import { Form, Button, Modal} from 'react-bootstrap';
//import firebase from '../firebase';
import { send } from 'emailjs-com';

 function ContactForm() {
   
  const [toSend, setToSend] = useState({
    from_name: '',
    to_name: '',
    message: '',
  });
  
    const [smShow, setSmShow] = useState(false);

    const onSubmit = (e) => {
      e.preventDefault();
      
      
      if(toSend.from_name.length < 3){
        alert('Please enter your name');
        return;
      }
      
      if(toSend.to_name === ""){
        alert('Please enter your email');
        return;
      }
              
      if(toSend.message.length < 10 || toSend.message.length >400){
        alert('Please enter your message not longer than 400 symbols');
         return;
      }
      
      send(
        'service_2w6uxxc',
        'template_va9o2zf',
        toSend,
        'user_PDmQFCVPg2tytEHb98KXG'
      )
        .then((response) => {
          setSmShow(true);
          //console.log('SUCCESS!', response.status, response.text);
        })
        .catch((err) => {
          alert('Įvyko klaida...', err);
        })
        
        setToSend({
          from_name: '',
          to_name: '',
          message: '',
        });
    };
  
    const handleChange = (e) => {
      setToSend({ ...toSend, [e.target.name]: e.target.value });
    };

  //  const handleSubmit = (e) => {
  //       e.preventDefault();//kad neprekratu formos
  //       

  //       firebase
  //       .firestore() 
  //       .collection('contacts-cv').add({ 
  //           name: name, 
  //           email: email,
  //           message: message,
  //           created: firebase.firestore.FieldValue.serverTimestamp()
  //  })
  //  .then(()=>{
  //     // alert('Thank you for your message');
  //      setSmShow(true);
       
  //  })
  //  .catch((err)=>{
  //      alert(err.message);
  //  })


  //   }

    return (
      
    <div className="row sestasblokas sonai text-white">
      <div className="col-12 pav1 text-center"> <p> KONTAKTAI</p></div>
      <div className="col-12"> <hr className="text-white-50"/></div>
      <div className="col-12 pav2 text-center"> Turite klausimų? Kilo idėjų ir jas reikia įgyvendinti? Norite bendradarbiauti  ar užsakyti paslaugas? Susisiekite!!!</div>
      <Form className="m-auto w-75" onSubmit={onSubmit}>
        <div className="form-group row">
          <div className="col-6 pl-0 ">
          <Form.Control type="text" name="from_name" className="form-control " placeholder="Jūsų vardas" value={toSend.from_name}
    onChange={handleChange}  required/>
          </div>
          <div class="col-6 pr-0 ">
          <Form.Control type="email" name="to_name" className="form-control " placeholder="Jūsų el. pašto adresas" value={toSend.to_name}
    onChange={handleChange} required/>
          </div>
        </div>
      <div className="form-group row ">
            <Form.Control className="form-control" name="message" id="exampleFormControlTextarea1" as="textarea" rows={3} placeholder="Jūsų žinutė"  
           value={toSend.message} onChange={handleChange} required/>
      </div>
      <div id="kontaktai"></div> 
      <div className="row pt-5">
        <Button className="button"  variant="amber"  active type="submit">SIŲSTI ŽINUTĘ</Button>
      
        <Modal
        size="sm"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Dėkoju, žinutė išsiųsta.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>Atsakymą pateiksiu kuo skubiau</Modal.Body>
      </Modal>

      </div>
    </Form>
 </div>

    )
}
export default ContactForm